const tradeInsurance = {
  state: {
    currMenuIndex: ''
  },
  getters: {
    currMenuIndex: (state) => state.currMenuIndex
  },
  mutations: {
    setCurrMenuIndex(state, index) {
      state.currMenuIndex = index
    }
  }
}

export default tradeInsurance
